class FormObservation {
  observation
  constructor (observation) {
    this.observation = observation
  }

  getField (defaultValues) {
    return {
      ...defaultValues,
      initialValues: {
        observation: this.observation
      }
    }
  }
}

export default FormObservation
